import ReactQuill from 'react-quill';

const BlockEmbed = ReactQuill.Quill.import('blots/block/embed');

class HorizontalLine extends BlockEmbed {
  static create() {
    let node = document.createElement('hr');
    node.setAttribute('horizontal-line', 'horizontal-line'); // добавляем атрибут
    node.classList.add('horizontal-line'); // добавляем класс
    return node;
  }
}
HorizontalLine.blotName = 'horizontal-line';
HorizontalLine.tagName = 'hr';

export default HorizontalLine;
